import { useState, useCallback } from 'react';
import { BankType } from '../../types/generatedTypes';
import { DanelFileInfo } from './types';

export const useDanelFileUploadItem = (
  file: DanelFileInfo,
  onBankChange: (bank: BankType) => void
) => {
  // Determine initial bank value based on detection results
  const getInitialBank = (): BankType | '' => {
    // If file was not detected or is ambiguous, user must select
    if (file.isDetected === false || file.isAmbiguous === true) {
      return '';
    }
    // If detected and not ambiguous, use the first detected bank
    if (
      file.isDetected === true &&
      file.detectedBanks &&
      file.detectedBanks.length > 0
    ) {
      return file.detectedBanks[0];
    }
    // Fallback to existing bank if any
    return file.bank || '';
  };

  const [selectedBank, setSelectedBank] = useState<BankType | ''>(
    getInitialBank()
  );

  const handleBankChange = useCallback(
    (bank: BankType) => {
      setSelectedBank(bank);
      onBankChange(bank);
    },
    [onBankChange]
  );

  const getBankOptions = (): BankType[] => [
    'leumi',
    'poalim',
    'discount',
    'fibi',
  ];

  const getBankDisplayName = (bank: BankType): string => {
    const displayNames: Record<BankType, string> = {
      leumi: 'Leumi',
      poalim: 'Poalim',
      discount: 'Discount',
      fibi: 'FIBI',
    };
    return displayNames[bank];
  };

  return {
    selectedBank,
    handleBankChange,
    getBankOptions,
    getBankDisplayName,
  };
};
